import React from 'react'
import styled from 'styled-components'
import ImageLoader from '@merchantlabs/gatsby-image-loader'

export default ({ sizes }) => {
  return (
    <ImageLoader sizes={sizes}>{({ src }) => <Image url={src} />}</ImageLoader>
  )
}

const Image = styled.div`
  border-radius: 10px;
  width: 700px;
  height: 500px;
  background-image: url(${props => props.url});
  background-size: cover;
  margin: 0 auto;

  @media (max-width: ${props => props.theme.tablet}px) {
    height: 201px;
    width: 350px;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    height: 172.5px;
    width: 300px;
  }
`
